<template>
  <div class="catalog-card">
    <div class="card-top">
      <a :href="buildUrl" class="top-image" @mouseover="onMouseover" @mouseleave="onMouseleave">
        <img
          v-for="(image, index) in images"
          :src="image.path"
          alt=""
          :key="image.id"
          :class="{ current: hoverIndex == index }"
        />
      </a>
      <div class="top-content">
        <div class="info">
          <div class="name">{{ item.title }}</div>
          <div class="price">{{ item.price ? "€ " + item.price : "PRE-ORDER" }}</div>
          <div class="info-feature">{{ item.short_description }}</div>
        </div>
        <div class="colors" v-if="item.builds.length > 0">
          <a
            v-for="(build, index) in item.builds"
            :key="index"
            class="color-ball"
            :title="build.color.title"
            :style="`background-image: url('${build.color.image}'); z-index: ${getIndex(index)}`"
            @click="changeBuild(build)"
          ></a>
          <div class="color-more" v-if="moreColors">
            <span>+{{ moreColors }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-bot" v-if="item.specs.length > 0">
      <div class="features">
        <div v-for="(spec, key) in item.specs" class="features-col" :key="key">
          <div class="features-list-title">{{ spec.title }}</div>
          <ul class="features-list">
            <!-- <li class="feature-item">{{ spec.pivot.title }}</li> -->
            <li class="feature-item">{{ spec.pivot.description }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item", "lang"],
  name: "CatalogCardComponent",
  data() {
    return {
      build: this.item.builds.length ? this.item.builds[0] : null,
      hoverIndex: 0,
      timer: null,
    };
  },
  mounted() {
    this.item.builds.forEach((build) => {
      build.media_content.files.slice(0, 3).forEach((file) => {
        const img = new Image();

        img.src = file.path;
      });
    });
  },
  computed: {
    moreColors() {
      return parseInt(this.item.builds_count) - parseInt(this.item.builds.length);
    },
    buildUrl() {
      let url
      if (this.build) {
        url = `/${this.lang}/catalog/${this.item.product.slug}/${this.build.family.toLowerCase().replace(/ /g, "-")}/${this.build.color.slug}/${this.build.id}`;
      } else {
        url = `/${this.lang}/choose/${this.item.product.slug}`;
      }

      return url;
    },
    images() {
      return _.get(this.build, "media_content.files", []).slice(0, 3);
    },
    mainImage() {
      return _.get(this.build, "media_content.preview");
    },
  },
  methods: {
    getIndex(index) {
      return 4 - index;
    },
    changeBuild(build) {
      this.build = build;
    },
    onMouseover() {
      clearInterval(this.timer);

      var max = this.images.length - 1;

      var index = this.hoverIndex;
      this.timer = setInterval(() => {
        index++;

        if (index > max) {
          index = 0;
        }

        this.hoverIndex = index;
      }, 1700);
    },
    onMouseleave() {
      clearInterval(this.timer);

      this.hoverIndex = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.color-ball {
  cursor: pointer;
}
.top-image {
  display: block;
  position: relative;
  //padding-top: 66.67%;
  padding-top: 74.5%;

  img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.7s ease-in-out 0s;
    mix-blend-mode: darken;

    &.current {
      opacity: 1;
    }
  }
}
</style>
